import { render } from "./OrderFeeDesc.vue?vue&type=template&id=a5444048&ts=true"
import script from "./OrderFeeDesc.vue?vue&type=script&lang=ts"
export * from "./OrderFeeDesc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__